import React from 'react';
import CardBillListContainer from './card-bill-list-container';

const CardBillListPage = () => {
  return <CardBillListContainer />;
};

export default CardBillListPage;
